import type { TicketDetailDto } from "@megaron/support-contracts";

export function updateTicketPayload(
  ticket: TicketDetailDto,
  patch: {
    subject?: string;
    status?: TicketDetailDto["status"];
    priority?: TicketDetailDto["priority"] | null;
    category?: TicketDetailDto["category"] | null;
    tags?: string[] | null;
    invoiceNumber?: string | null;
    orderNumber?: string | null;
  },
) {
  return {
    id: ticket.id,
    subject: patch.subject ?? ticket.subject,
    status: patch.status ?? ticket.status,
    priority: patch.priority !== undefined ? patch.priority : ticket.priority ?? null,
    category: patch.category !== undefined ? patch.category : ticket.category ?? null,
    tags: patch.tags !== undefined ? patch.tags : ticket.tags,
    invoiceNumber:
      patch.invoiceNumber !== undefined ? patch.invoiceNumber : ticket.invoiceNumber ?? null,
    orderNumber: patch.orderNumber !== undefined ? patch.orderNumber : ticket.orderNumber ?? null,
  };
}
